export const decodeHtml = (html: string) => {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  const decodedHtml = txt.value;

  return decodedHtml.replace(/^<p>(.*?)<\/p>$/, "$1");
};
